<h2 mat-dialog-title>{{ 'components.picost.save-picost' | translate }}</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ 'components.picost.picost-name' | translate }}</mat-label>
    <input
      matInput
      [(ngModel)]="name"
      name="name"
      (keydown.enter)="confirm()"
      cdkFocusInitial
      autocomplete="off"
    />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">
    {{ 'generic.cancel' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="!name.trim()"
    (click)="confirm()"
  >
    <mat-icon class="mr-1">save</mat-icon>
    {{ 'generic.buttons.save' | translate }}
  </button>
</mat-dialog-actions>
